var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleplay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1477 500",
    enableBackground: "new 0 0 1477 500",
    width: 2500,
    height: 846,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#fff}.st1{fill:url(#orange_1_)}.st2{fill:url(#path-3_2_)}.st3{filter:url(#Adobe_OpacityMaskFilter)}.st4{mask:url(#mask-4);fill:none}.st5{filter:url(#Adobe_OpacityMaskFilter_1_)}.st6{mask:url(#mask-6);fill:url(#Fill-7_3_)}.st7{fill:url(#path-9_2_)}.st8{filter:url(#Adobe_OpacityMaskFilter_2_)}.st9{mask:url(#mask-10);fill:none}")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Google") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard-1",
    transform: "translate(-461 -270)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Play-Store",
    transform: "translate(461 270)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "background",
    className: "st0",
    d: "M60 0h1357c33.1 0 60 26.9 60 60v380c0 33.1-26.9 60-60 60H60c-33.1 0-60-26.9-60-60V60C0 26.9 26.9 0 60 0z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(60 179)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "orange_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -70.717,
    y1: 570.714,
    x2: -70.398,
    y2: 570.201,
    gradientTransform: "matrix(234.0913 0 0 -256.5288 16609.81 146485.188)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff177b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffec73"
  })), /*#__PURE__*/React.createElement("path", {
    id: "orange",
    className: "st1",
    d: "M120.2 61S18.3 4.5 12.3 1.2C6.3-2.1.3-.1.3 6.8v243.5c0 5.2 4.3 7.4 9.5 4.6 5.2-2.9 110.4-61.2 110.4-61.2s14.3-7.9 21.4-11.9c11.5-6.4 34.5-19.1 34.5-19.1s47.5-26.3 53.8-29.8c6.3-3.5 5.7-8.3.4-11-5.3-2.7-54.1-30-54.1-30l-56-30.9z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "blue"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "path-3_2_",
    gradientUnits: "userSpaceOnUse",
    x1: -70.261,
    y1: 571.394,
    x2: -70.632,
    y2: 569.943,
    gradientTransform: "matrix(139 0 0 -256 9858 146183)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#064aa2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#63ffd4"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path-3_1_",
    className: "st2",
    d: "M139 127L5 0C1.9.7 0 3.1 0 7v243c0 3.3 1.3 5.3 3 6l136-129z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 0,
    y: 0.1,
    width: 234,
    height: 257
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0.1,
    width: 234,
    height: 257,
    id: "mask-4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-3",
    className: "st0",
    d: "M139 127L5 0C1.9.7 0 3.1 0 7v243c0 3.3 1.3 5.3 3 6l136-129z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    className: "st4",
    d: "M176 92l-56-31c-.2.5-102.1-56.1-108-59C6-1.8 0 .3 0 7v244c0 5.4 4.3 7.6 9 5 5.7-3.2 110.8-61.5 111-62l56-31c-.3.4 47.1-25.9 53-29 6.8-3.9 6.1-8.7 1-11-5.5-3.2-54.3-30.5-54-31"
  })), /*#__PURE__*/React.createElement("g", {
    id: "red",
    transform: "translate(2.983 127.504)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_1_",
    filterUnits: "userSpaceOnUse",
    x: -3,
    y: -127.4,
    width: 234,
    height: 257
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: -127.4,
    width: 234,
    height: 257,
    id: "mask-6"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-5",
    className: "st0",
    d: "M5.5 127.8L83 85.2c19.1-10.6 34.2-19 34.2-19l56.3-30.3L136-.5 0 128.5c1.5.5 4.2.2 6.3-.8"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Fill-7_3_",
    gradientUnits: "userSpaceOnUse",
    x1: -73.347,
    y1: 443.327,
    x2: -74.108,
    y2: 442.827,
    gradientTransform: "matrix(233.965 0 0 -256.9642 17295.543 113843.219)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff4521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8a33db"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Fill-7",
    className: "st6",
    d: "M117-66.5c-.2.5-102.1-56.1-108-59-6-3.8-12-1.7-12 5v244c0 5.4 4.3 7.6 9 5 5.7-3.2 110.8-61.5 111-62l56-31c-.3.4 47.1-25.9 53-29 6.8-3.9 6.1-8.7 1-11-5.5-3.2-54.3-30.5-54-31l-56-31z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "green",
    transform: "translate(4.98)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-5"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "path-9_2_",
    gradientUnits: "userSpaceOnUse",
    x1: -75.767,
    y1: 570.364,
    x2: -75.125,
    y2: 569.122,
    gradientTransform: "matrix(171.2139 0 0 -127.4293 12997.62 72640.227)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a3b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d6ffa1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path-9_1_",
    className: "st7",
    d: "M7.1 1.1C4.5-.2 2-.6-.1-.1L134 127.1 171.1 92l-55.9-31S62.5 31.8 30.7 14.2L7.1 1.1z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_2_",
    filterUnits: "userSpaceOnUse",
    x: -5,
    y: 0.1,
    width: 234,
    height: 257
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: -5,
    y: 0.1,
    width: 234,
    height: 257,
    id: "mask-10"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-9",
    className: "st0",
    d: "M7.1 1.1C4.5-.2 2-.6-.1-.1L134 127.1 171.1 92l-55.9-31S62.5 31.8 30.7 14.2L7.1 1.1z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Fill-4",
    className: "st9",
    d: "M171 92l-56-31c-.2.5-102-56.1-108-59C1-1.8-5 .3-5 7v244c0 5.4 4.3 7.6 9 5 5.7-3.2 110.8-61.5 111-62l56-31c-.3.4 47.1-25.9 53-29 6.8-3.9 6.1-8.7 1-11-5.5-3.2-54.3-30.5-54-31"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Google-play",
    transform: "translate(347 201)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1_1_",
    d: "M664.6 147.9l-11.1 10.5c-2.6 1.4-5.1 3.1-7.6 4.2-7.7 3.5-15.5 4.4-22.5 4.4-7.4 0-19-.5-30.8-9.1-16.4-11.6-23.6-31.7-23.6-49.1 0-36.1 29.2-53.8 53.1-53.8 8.3 0 16.9 2.1 23.8 6.5 11.6 7.7 14.6 17.7 16.2 23.1l-54.4 22.1-17.8 1.4c5.8 29.6 25.7 46.8 47.7 46.8 11 0 19.1-3.6 26.6-7.3 0 0 1.5-.8.4.3zm-33.2-59.4c4.4-1.6 6.6-3 6.6-6.3 0-9.4-10.3-20.2-22.7-20.2-9.1 0-26.3 7.3-26.3 32.6 0 4 .5 8.2.7 12.4l41.7-18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-2",
    d: "M551 146.6c0 9 1.6 10.4 9.2 11.1 4 .5 7.9.7 11.8 1.1l-8.5 5.1h-40.7c5.3-7 6.3-7.7 6.3-12.3v-5.2l-.1-138h-18L528.3 0h33c-7.2 4.2-9.3 6.7-10.2 14.8l-.1 131.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-3",
    d: "M487.9 66.4c5.3 4.4 16.3 13.7 16.3 31.3 0 17.2-9.6 25.3-19.3 33-3 3-6.5 6.3-6.5 11.4 0 5.1 3.5 7.9 6 10l8.3 6.5c10.1 8.6 19.3 16.5 19.3 32.5 0 21.8-21 43.9-60.6 43.9-33.4 0-49.5-16-49.5-33.2 0-8.4 4.1-20.2 17.8-28.3 14.3-8.8 33.6-10 44-10.7-3.2-4.2-6.9-8.6-6.9-15.8 0-3.9 1.2-6.3 2.3-9.1-2.5.2-5.1.5-7.4.5-24.4 0-38.2-18.4-38.2-36.5 0-10.7 4.8-22.5 14.8-31.1C441.4 59.9 457.1 58 469.5 58H517l-14.8 8.4h-14.3zm-16.2 102.9c-1.9-.3-3-.3-5.3-.3-2.1 0-14.7.5-24.4 3.8-5.1 1.9-20 7.6-20 24.4 0 16.8 16 28.9 40.9 28.9 22.3 0 34.1-10.9 34.1-25.5 0-12.2-7.7-18.6-25.3-31.3zm6.5-44.8c5.3-5.3 5.8-12.7 5.8-16.9 0-16.7-9.8-42.6-28.9-42.6-5.9 0-12.4 3-16.1 7.7-3.9 4.8-5 11.1-5 17.1 0 15.5 9 41.2 28.7 41.2 5.7 0 11.9-2.8 15.5-6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-4_1_",
    d: "M344.3 167c-36.7 0-56.3-29-56.3-55.2 0-30.6 24.7-56.8 59.8-56.8 33.9 0 55.2 26.9 55.2 55.2 0 27.6-21 56.8-58.7 56.8zm28.7-18.9c5.6-7.5 7-16.9 7-26 0-20.7-9.7-60.1-38.5-60.1-7.6 0-15.3 3-20.9 8-9 8.2-10.7 18.5-10.7 28.6 0 23.2 11.3 61.4 39.4 61.4 9.2 0 18.4-4.4 23.7-11.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-5",
    d: "M221.3 167c-36.7 0-56.3-29-56.3-55.2 0-30.6 24.7-56.8 59.8-56.8 33.9 0 55.2 26.9 55.2 55.2 0 27.6-21 56.8-58.7 56.8zm28.7-18.9c5.6-7.5 7-16.9 7-26 0-20.7-9.8-60.1-38.5-60.1-7.7 0-15.3 3-20.9 8-9.1 8.2-10.7 18.5-10.7 28.6 0 23.2 11.4 61.4 39.4 61.4 9.2 0 18.4-4.4 23.7-11.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-6",
    d: "M149.8 160.1l-31.1 7.2c-12.6 2-23.9 3.8-35.9 3.8C22.8 171 0 126.6 0 91.8 0 49.4 32.4 10 87.8 10c11.7 0 23 1.7 33.3 4.6 16.3 4.6 23.9 10.3 28.7 13.6l-18.1 17.3-7.6 1.7 5.4-8.7c-7.4-7.2-20.9-20.6-46.5-20.6-34.3 0-60.2 26.2-60.2 64.5 0 41.1 29.5 79.8 76.9 79.8 13.9 0 21.1-2.8 27.6-5.4v-35.3l-32.8 1.8 17.4-9.4H158l-5.6 5.5c-1.5 1.3-1.7 1.7-2.2 3.5-.2 2-.4 8.3-.4 10.6v26.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-7_1_",
    d: "M731.7 148.9V208H720V57.7h11.7v17.1c7.6-11.1 21.6-19.8 37.7-19.8 29 0 48.6 22.1 48.6 57 0 34.7-19.5 57.2-48.6 57.2-15.2 0-28.9-7.9-37.7-20.3zm74.3-36c0-26.6-13.7-46.9-38.1-46.9-15.1 0-29.6 12-35.9 22.5v48.6c6.3 10.5 20.8 22.9 35.9 22.9 24.4 0 38.1-20.5 38.1-47.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-8",
    d: "M834 16h12v151h-12V16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-9",
    d: "M976.5 197.6c2.5 1.1 6.8 1.8 9.5 1.8 7.2 0 12.1-2.9 16.6-13.3l8.5-19.4L965 57h13.1l39.5 95.1 39.2-95.1h13.2l-56.2 132.7c-5.8 13.7-15 20.3-27.6 20.3-3.8 0-8.8-.7-11.7-1.6l2-10.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-10",
    d: "M943.4 166.9c-.8-3.8-1.4-7.1-1.8-9.9-.4-2.8-.6-5.6-.6-8.5-4 5.9-9.7 10.9-17.1 14.8-7.3 3.9-14.3 5.8-23.8 5.8-11.5 0-20.4-2.8-26.7-8.6-6.3-5.7-9.5-13.5-9.5-23.3s4.6-17.8 13.8-23.9c9.2-6.1 21.1-9.2 35.8-9.2h27.4V90.5c0-7.8-2.7-14-8-18.4-5.3-4.5-12.8-6.7-22.5-6.7-8.9 0-16.1 2.1-21.6 6.1-5.4 4.1-8.2 9.2-8.2 15.3h-12l-.2-.6c-.4-8.3 3.3-15.5 11.4-21.8 8-6.3 18.4-9.4 31.3-9.4 12.8 0 23.2 3.1 31 9.3 7.8 6.1 11.7 15 11.7 26.5v54c0 3.9.2 7.6.7 11.3.5 3.7 1.3 7.3 2.3 10.8h-13.4zm-41.8-7.9c10 0 17.2-2.3 24.5-6.7 7.3-4.4 12.2-10.2 14.8-17.2V114h-27.6c-10.5 0-19.2 2.3-26.1 7.1-6.9 4.7-10.3 10.4-10.3 17.1 0 6.3 2.2 11.3 6.6 15.1 4.5 3.8 10.5 5.7 18.1 5.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Get-it-on",
    transform: "translate(343 79)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1_2_",
    d: "M0 36.3C0 14.8 17.2.9 38.6.9c14.3 0 23.7 6.4 29.6 14.2l-10.5 5.6c-4-5.1-10.9-9.1-19.1-9.1-14.5 0-25.4 10.3-25.4 24.7C13.3 50.6 24.1 61 38.6 61c7.5 0 14.1-3.2 17.4-6.2V44.3H34V33.7h34.8v25.5c-7.2 7.5-17.5 12.5-30.2 12.5C17.2 71.8 0 57.8 0 36.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-2_1_",
    d: "M85.5 70.8V2h51.1v10.6h-38v17.7h37.2V41H98.6v19.2h38v10.6H85.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-3_1_",
    d: "M171.3 70.8V12.6h-22.2V2h57.3v10.6h-22.2v58.2h-12.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-4_2_",
    d: "M252.3 2h12.5v68.8h-12.5V2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-5_1_",
    d: "M300.6 70.8V12.6h-22.2V2h57.3v10.6h-22.2v58.2h-12.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-6_1_",
    d: "M378.5 36.4C378.5 16 394.2 1 416.6 1c22.2 0 38 15 38 35.4s-15.9 35.4-38 35.4c-22.4 0-38.1-15-38.1-35.4zm62.5-.6c0-14-9.6-24.5-24.5-24.5-15 0-24.5 10.5-24.5 24.5 0 13.9 9.5 24.5 24.5 24.5 14.9 0 24.5-10.5 24.5-24.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-7_2_",
    d: "M520.3 70.8L482 21.6v49.2h-12.9V2h13.2l37.5 47.7V2h12.9v68.8h-12.4"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleplay);
export default __webpack_public_path__ + "static/media/googleplay.5e937d36347509532788c0fff7644b5f.svg";
export { ForwardRef as ReactComponent };